var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6673 13.3333V15C16.6673 15.9205 15.9211 16.6667 15.0007 16.6667H5.00065C4.08018 16.6667 3.33398 15.9205 3.33398 15V13.3333M14.1673 7.50001L10.0007 3.33334M10.0007 3.33334L5.83398 7.50001M10.0007 3.33334V13.3333",
    stroke: "black",
    strokeOpacity: 0.77,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExport);
export default __webpack_public_path__ + "static/media/icon-export.5890c90970ea88b58fd30b2344c4b99e.svg";
export { ForwardRef as ReactComponent };